export default "__VITE_ASSET__B0G_120Y__"